import { gql } from "@apollo/client"

const GET_SITE_DATA_STUDENTS_XLS_DOWNLOAD_LINK = gql`
  query GetStudentsXlsDownload($clientId: ID!) {
    dataStudentsXlsDownload(client_id: $clientId) {
      filename
      type
      url
      queued
    }
  }
`

export { GET_SITE_DATA_STUDENTS_XLS_DOWNLOAD_LINK }
